import { throttle } from '@neux/ui-jquery/tool';
export default function () {
  let windowScrollValue = 0;
  function mobileMenuClose() {
    $('.header, body').removeClass('mobile-menu--open');

    $('html').removeClass('scroll-lock').removeAttr('style');
    $(window).scrollTop(windowScrollValue);
  }
  $('.header__mobile-menu-btn').on('click', function () {
    if ($('.header').hasClass('mobile-menu--open')) {
      mobileMenuClose();
    } else {
      $('.header, body').addClass('mobile-menu--open');
      windowScrollValue = window.pageYOffset || document.documentElement.scrollTop;;
      $('html').css({
        'left': 0,
        'top': -windowScrollValue
      }).addClass('scroll-lock');
    }
  });
  $('.header-mobile__backdrop').on('click', mobileMenuClose);
  throttle(
    $(window).on('resize', function () {
      if ($('.header').hasClass('mobile-menu--open') && $(window).outerWidth() > 1159) {
        // $medium-1
        // 解除menu-open狀態
        mobileMenuClose();
      }
    })
  )
}